import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="block mb-1.5 font-mono text-[10px] uppercase tracking-wider text-slate-400">{label}</span>
    {children}
  </label>
);

const cls = "h-9 bg-[#0B0F19] border-slate-700 font-mono text-sm focus-visible:ring-cyan-500";

export const NumField = ({ label, value, onChange, testid, min = 1 }) => (
  <Field label={label}>
    <Input data-testid={testid} type="number" min={min} value={value} className={cls}
      onChange={(e) => onChange(e.target.value === "" ? "" : Math.max(0, parseInt(e.target.value, 10) || 0))}
      onBlur={(e) => { if (!e.target.value || +e.target.value < min) onChange(min); }} />
  </Field>
);

export const TextField = ({ label, value, onChange, testid, list, area }) => (
  <Field label={label}>
    {area ? <Textarea data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} className="bg-[#0B0F19] border-slate-700 text-sm min-h-[70px]" />
      : <Input data-testid={testid} list={list} value={value || ""} onChange={(e) => onChange(e.target.value)} className={`${cls} font-sans`} />}
  </Field>
);
